// extracted by mini-css-extract-plugin
export var accordion_content = "styles-module--accordion_content--Wr9jx";
export var accordion_trigger = "styles-module--accordion_trigger--kH4H-";
export var action_wrapper = "styles-module--action_wrapper--B2fyJ";
export var blink = "styles-module--blink--dbgmE";
export var c_mobile_navigation = "styles-module--c_mobile_navigation--nhDjl";
export var content_wrapper = "styles-module--content_wrapper--pGT5V";
export var link = "styles-module--link--+FVUw";
export var navigation_menu_content = "styles-module--navigation_menu_content--XD4j6";
export var trigger = "styles-module--trigger--DpqeL";